module.exports = __webpack_public_path__ + "svg/double-chevron-right-think.98ae12fc814605542277213d8fef93ec.svg";